import { useEffect } from 'react'

import { commonRepo } from '~/@common/services/repo.service'
import { mixpanelClient } from '~/@common/utils/trackings/mixpanel'
import { convertAcademyAndStudentToGlobalEventProperty } from '~/@common/utils/trackings/schema/globalEventProperties.schema'
import { convertAcademyToUserProperties } from '~/@common/utils/trackings/schema/userProperties.schema'

import { datadogClient } from '../init/datadog'

export const useDataTracking = () => {
  useEffect(() => {
    if (commonRepo.academy && commonRepo.student) {
      // Mixpanel MTU 과금 정책: 프리미엄 학원 소속 "학생"에 한해 트래킹.
      // PARENT(학부모) 및 BASIC/SOLO 학원 유저는 opt-out 상태를 유지하여 이벤트가 전송되지 않게 한다.
      const shouldTrack = !commonRepo.permission.isParent && commonRepo.permission.isPremium

      if (shouldTrack) {
        mixpanelClient.optInTracking()
        mixpanelClient.identify(commonRepo.student.id)

        mixpanelClient.setGlobalEventProperty({
          ...convertAcademyAndStudentToGlobalEventProperty({
            academy: commonRepo.academy,
            student: commonRepo.student,
          }),
        })
        datadogClient.setGlobalContextProperty('academy', commonRepo.academy)
        datadogClient.setGlobalContextProperty('student', commonRepo.student)

        mixpanelClient.setUserProperty({
          ...convertAcademyToUserProperties({
            academy: commonRepo.academy,
          }),
        })
      } else {
        mixpanelClient.optOutTracking()
      }

      if (commonRepo.academy.academyId) {
        datadogClient.setAccount({
          ...commonRepo.academy,
          id: commonRepo.academy.academyId,
        })
      }
    }
  }, [commonRepo.academy, commonRepo.student])
}
